import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { API } from "../App";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Mail, CheckCircle, XCircle, Loader2 } from "lucide-react";

const UnsubscribePage = () => {
  const { userId } = useParams();
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const unsubscribe = async () => {
      try {
        const res = await axios.get(`${API}/unsubscribe/${userId}`);
        setStatus("success");
        setMessage(res.data.message);
      } catch (e) {
        setStatus("error");
        setMessage(e.response?.data?.detail || "Failed to unsubscribe. Please try again.");
      }
    };

    if (userId) {
      unsubscribe();
    }
  }, [userId]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="glass-card p-8 max-w-md w-full text-center">
        {status === "loading" && (
          <>
            <Loader2 className="w-16 h-16 text-primary mx-auto mb-4 animate-spin" />
            <h1 className="text-2xl font-bold text-white mb-2">Processing...</h1>
            <p className="text-white/60">Please wait while we update your preferences.</p>
          </>
        )}

        {status === "success" && (
          <>
            <CheckCircle className="w-16 h-16 text-green-400 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-white mb-2">Unsubscribed</h1>
            <p className="text-white/60 mb-6">{message}</p>
            <p className="text-white/40 text-sm mb-6">
              You will no longer receive marketing emails from PourCircle.
              You can re-subscribe anytime in the app settings.
            </p>
            <Link to="/">
              <Button className="btn-primary">
                Return to PourCircle
              </Button>
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <XCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-white mb-2">Error</h1>
            <p className="text-white/60 mb-6">{message}</p>
            <Link to="/">
              <Button className="btn-primary">
                Return to PourCircle
              </Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default UnsubscribePage;
